import { render, staticRenderFns } from "./backoffice-regulacao.vue?vue&type=template&id=34a961ec&scoped=true"
import script from "./backoffice-regulacao.vue?vue&type=script&lang=ts"
export * from "./backoffice-regulacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a961ec",
  null
  
)

export default component.exports